// extracted by mini-css-extract-plugin
module.exports = {"header":"k0DJK","title":"_3sTZx"};